const styles = ':host{--skapa-status-inner-margin:max(0.5rem,.4em);--min-size:0.75rem;--size:max(var(--min-size),.4em);--border-width:calc(var(--size)/6);align-items:baseline;display:flex}:host svg{background:none;border-radius:var(--size);bottom:max(1ex - var(--size) + var(--border-width)/4,-1 * var(--border-width)/4);color:var(--skapa-status-colour);display:inline-block;flex-basis:var(--size);flex-grow:0;flex-shrink:0;margin-inline-end:var(--skapa-status-inner-margin);order:-1;position:relative;transform:scale(.999);width:var(--size)}:host([position=inline]) svg,:host([position=trailing]) svg{margin-inline-end:unset;margin-inline-start:var(--skapa-status-inner-margin);order:1}:host([position=inline]){display:inline;white-space:nowrap}:host([position=inline]) slot{display:inline;white-space:normal}.glue{font-size:0;white-space:nowrap}:host([small]){--min-size:0.5rem;--border-width:0}:host([small]) svg{background:currentColor}:host([colour=green]){--skapa-status-colour:rgb(var(--colour-semantic-positive,10,138,0))}:host([colour=orange]){--skapa-status-colour:rgb(var(--colour-semantic-caution,242,106,47))}:host([colour=red]){--skapa-status-colour:rgb(var(--colour-semantic-negative,224,7,81))}:host([colour=grey]){--skapa-status-colour:rgb(var(--colour-text-and-icon-4,146,146,146))}';
import * as Icons from "./elements/icons.js";
import { SkapaElement } from "@ingka/skapa-webc-element";
const iconForColour = {
  green: Icons.availablePath,
  orange: Icons.lowAvailabilityPath,
  red: Icons.unavailablePath,
  grey: Icons.indeterminatePath
};
function generateTemplate({ html }) {
  const template = document.createElement("template");
  template.innerHTML = html`<style>
      ${styles}
    </style>
    <slot></slot><span class="glue" aria-hidden="true">&nbsp;</span
    ><svg viewBox="0 0 12 12" aria-hidden="true"></svg>`;
  return { main: template };
}
class Status extends SkapaElement {
  constructor() {
    super();
    this.updateIcon = () => {
      if (this.colour && iconForColour[this.colour])
        this.embeddedSVG.innerHTML = iconForColour[this.colour];
    };
    this.gatherProperties(["colour", "small", "position"], this);
    const shadow = this.attachShadow({ mode: "open" });
    const { main } = this.getTemplates(generateTemplate);
    shadow.append(main.content.cloneNode(true));
    this.embeddedSVG = shadow.querySelector("svg");
  }
  connectedCallback() {
    this.updateIcon();
  }
  get colour() {
    return this.getAttribute("colour");
  }
  set colour(value) {
    if (value)
      this.setAttribute("colour", value);
    else
      this.removeAttribute("colour");
  }
  get small() {
    return this.hasAttribute("small");
  }
  set small(toggle) {
    this.toggleAttribute("small", !!toggle);
  }
  get position() {
    return this.getAttribute("position") || "leading";
  }
  set position(value) {
    this.setAttribute("position", value || "leading");
  }
  attributeChangedCallback() {
    this.updateIcon();
  }
}
Status.skapaTagName = "status";
Status.skapaDependencies = [];
Status.observedAttributes = ["colour"];
var Status_default = Status;
export {
  Status,
  Status_default as default
};
